import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';

import { useRemoveHost } from '@/features/hosts/hooks/mutation/use-remove-host';

interface Props extends DialogActions {
  selectedHostId: number;
  selectedHostEmail: string;
}

const RemoveHostDialog = ({ open, onCancel, selectedHostId, selectedHostEmail }: Props) => {
  const { t } = useTranslation(['hosts', 'common']);

  const { mutate, isPending } = useRemoveHost(onCancel);

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      variant="warning"
      title={t('hosts:dialogs.remove.title')}
      isConfirmButtonSubmitting={isPending}
      confirmButtonText={t('common:button.delete')}
      isConfirmButtonDisabled={!selectedHostId}
      onConfirm={() => mutate(selectedHostId)}>
      <Typography sx={{ my: 2 }} variant="subtitle2">
        {t('hosts:dialogs.remove.message')}{' '}
        <span style={{ fontWeight: 700 }}>{selectedHostEmail}</span>
      </Typography>
    </Dialog>
  );
};

export default RemoveHostDialog;
